import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { useState } from 'react';

export default function CrowdfundingPressReleasePage() {
  const [showSchedule, setShowSchedule] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-megaphone-line text-4xl text-white"></i>
              </div>
            </div>
            <div className="inline-block bg-gradient-to-r from-teal-500 to-blue-500 text-white px-6 py-2 rounded-full font-bold text-sm mb-6">
              プレスリリース
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              クラファン開始のお知らせ
            </h1>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
              財恩工房は、居場所とボランティアをやさしくつなぐ学習支援サービス「ボラタス」を通じて、こどもたちの学びを支える取り組みを進めています。<br />
              このたび、居場所でボラタスを利用するためのポイントを届けることを目的に、クラウドファンディングを開始しました。
            </p>
          </div>
        </div>
      </section>

      {/* 背景 */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            背景
          </h2>
          <div className="bg-gradient-to-br from-gray-50 to-orange-50 rounded-3xl p-8 md:p-12 border-2 border-gray-100">
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mr-3 flex-shrink-0 mt-1"></i>
                <span className="text-lg text-gray-700 leading-relaxed">居場所では人手不足が課題になりやすい</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mr-3 flex-shrink-0 mt-1"></i>
                <span className="text-lg text-gray-700 leading-relaxed">「必要な時に、必要な支援が届く」仕組みが必要</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mr-3 flex-shrink-0 mt-1"></i>
                <span className="text-lg text-gray-700 leading-relaxed">オンラインを活用して、無理なく支援がつながる形を目指す</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 取り組み概要 */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-50 to-orange-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            取り組み概要（ボラタスでできること）
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-3xl p-8 shadow-lg border-2 border-teal-100">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-map-pin-user-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">居場所</h3>
              <p className="text-gray-700 leading-relaxed">
                必要な時に学習サポートの依頼を出せる
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg border-2 border-orange-100">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hand-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">ボランティア</h3>
              <p className="text-gray-700 leading-relaxed">
                オンラインで学習支援に参加できる
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg border-2 border-amber-100">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">安心設計</h3>
              <p className="text-gray-700 leading-relaxed">
                こどもはニックネームで利用できる等、安心に配慮
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 今回のクラファンで実現したいこと */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            今回のクラファンで実現したいこと
          </h2>
          <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 md:p-12 border-2 border-pink-100 mb-8">
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-pink-600 text-xl mr-3 flex-shrink-0 mt-1"></i>
                <span className="text-lg text-gray-700 leading-relaxed">集まった支援を「居場所のボラタス利用ポイント」に充当し、居場所の負担を減らす</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-pink-600 text-xl mr-3 flex-shrink-0 mt-1"></i>
                <span className="text-lg text-gray-700 leading-relaxed">第1期〜第3期で参加居場所を増やしながら実施・報告していく</span>
              </li>
            </ul>
          </div>

          {/* スケジュール（折りたたみ） */}
          <div className="bg-white rounded-3xl p-8 border-2 border-gray-200">
            <button
              onClick={() => setShowSchedule(!showSchedule)}
              className="w-full flex items-center justify-between text-left cursor-pointer"
            >
              <h3 className="text-xl font-bold text-gray-900 flex items-center">
                <i className="ri-calendar-line text-teal-600 text-2xl mr-3"></i>
                第1期〜第3期の予定（スケジュール）
              </h3>
              <i className={`ri-arrow-${showSchedule ? 'up' : 'down'}-s-line text-2xl text-gray-600 transition-transform`}></i>
            </button>
            {showSchedule && (
              <div className="mt-6 space-y-4 text-gray-700 leading-relaxed pt-6 border-t-2 border-gray-100">
                <div className="flex items-start">
                  <span className="inline-block bg-gradient-to-br from-teal-500 to-orange-500 text-white font-bold px-3 py-1 rounded-lg text-sm mr-3 flex-shrink-0">第1期</span>
                  <p>クラウドファンディング実施・初期参加居場所での運用開始</p>
                </div>
                <div className="flex items-start">
                  <span className="inline-block bg-gradient-to-br from-orange-500 to-amber-500 text-white font-bold px-3 py-1 rounded-lg text-sm mr-3 flex-shrink-0">第2期</span>
                  <p>参加居場所の拡大・運用実績の報告</p>
                </div>
                <div className="flex items-start">
                  <span className="inline-block bg-gradient-to-br from-amber-500 to-orange-500 text-white font-bold px-3 py-1 rounded-lg text-sm mr-3 flex-shrink-0">第3期</span>
                  <p>さらなる拡大と持続可能な仕組みづくり</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 参加方法は3つ（最重要） */}
      <section className="py-20 px-4 bg-gradient-to-br from-orange-50 via-amber-50 to-teal-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
            あなたの参加方法を選べます
          </h2>
          <p className="text-lg text-gray-600 mb-12 text-center leading-relaxed">
            支援する・居場所として参加する・ボランティアとして参加する
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {/* 支援する */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-pink-100 text-center hover:shadow-2xl transition-all">
              <div className="w-20 h-20 bg-gradient-to-br from-pink-500 to-rose-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-3-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">支援する</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                クラウドファンディングで居場所を応援
              </p>
              <a
                href="https://for-good.net/project/1003002"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-pink-500 to-rose-500 text-white px-8 py-4 rounded-xl font-bold hover:shadow-2xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line mr-2"></i>
                クラファンページを見る
              </a>
            </div>

            {/* 居場所として参加 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-orange-100 text-center hover:shadow-2xl transition-all">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-home-heart-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">居場所として参加</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                ボラタスを活用して学習支援を
              </p>
              <a
                href="https://kyo-colle.com/ibasho-cf/index.html"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-orange-500 to-amber-500 text-white px-8 py-4 rounded-xl font-bold hover:shadow-2xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line mr-2"></i>
                居場所募集ページへ
              </a>
            </div>

            {/* ボランティアとして参加 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-teal-100 text-center hover:shadow-2xl transition-all">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">ボランティアとして参加</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                オンラインでこどもたちをサポート
              </p>
              <a
                href="/news/volunteer-recruitment"
                className="inline-block bg-gradient-to-r from-teal-500 to-orange-500 text-white px-8 py-4 rounded-xl font-bold hover:shadow-2xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-right-line mr-2"></i>
                ボランティア募集ページへ
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 取材・お問い合わせ */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            取材・お問い合わせ
          </h2>
          <div className="bg-gradient-to-br from-gray-50 to-teal-50 rounded-3xl p-8 md:p-12 border-2 border-teal-100 text-center">
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              取材・協業・参加のご相談など、お気軽にお問い合わせください。
            </p>
            <a
              href="/contact"
              className="inline-block bg-gradient-to-r from-teal-500 to-orange-500 text-white px-10 py-5 rounded-xl font-bold text-lg hover:shadow-2xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              お問い合わせフォームへ
            </a>
          </div>
        </div>
      </section>

      {/* 財恩工房について */}
      <section className="py-20 px-4 bg-gradient-to-br from-orange-50 to-amber-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            財恩工房について
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-8">
            財恩工房は、こどもたちの学びと成長を支える取り組みを通じて、<br />
            誰もが安心して学べる社会の実現を目指しています。
          </p>
          <a
            href="/story"
            className="inline-flex items-center text-teal-600 font-bold text-lg hover:text-teal-700 transition-colors cursor-pointer"
          >
            詳しくはストーリーへ
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
